import { useEffect, useState, useRef, useCallback } from 'react';
import QRCode from 'qrcode.react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
import dynamic from 'next/dynamic';
import css from './index.module.scss';
import NextImage from '@/components/NextImage';
import { useLang } from '@/i18n';
import EFBladeiCIcon1 from '@/components/UI/svg/blade/Icon/EFBladeiCIcon1';
import EFArrowRight from '@/components/UI/svg/blade/Icon/EFArrowRight';
import Model3D from '@/components/Model3D';
import { useGlobal } from '@/utils/useGlobal';
import EFArrowDown from '@/components/UI/svg/Icons/EFArrowDown';

const WinCard: any = dynamic(() => import('../WinCard'), { ssr: true });

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);

const icon = {
    width: 60,
    height: 60,
    isAlwaysShow: false, // icon总是显示
    iconPositionBetween: 180, // icon距离容器侧边边距
};
const list = {
    listGap: 20, // list之间间隔
    listWidth: 480,
    listHeight: 470,
};
const animation = {
    translateX: 470, // 容器中初始ul的偏移量
    steps: 1, // 一次滑动list的个数
    duration: 500, // 一次动画效果的时长 ms
    delay: 0, // 动画延迟时间 ms
    fill: 'forwards', // 动画执行是否应用样式 none, forwards, backwords, both, initial, inherit
    easing: 'ease', // 动画执行速度 linear,ease, ease-in, ease-out, ease-in-out, steps(int,start|end), cubic-bezier(n,n,n,n)
    iterations: 1, // 动画执行次数
};

export default function Other() {
    const { useRouter, Link } = useGlobal();
    const router = useRouter();
    const { t } = useLang('bladeroboticlawnmower');
    const [openWinCarFlag, setOpenWinCarFlag] = useState(false);
    const [qrcodeUrl, setQRCodeUrl] = useState<string>(''); // 给个默认值
    const domRef = useRef<HTMLDivElement>(null);
    const domChildRef = useRef<HTMLDivElement>(null);
    const arrLeftRef = useRef<Array<number>>([0]);
    const arrWidthRef = useRef<Array<number>>([]);

    const domRef2 = useRef<HTMLDivElement>(null);
    const domChildRef2 = useRef<HTMLDivElement>(null);
    const arrTopRef = useRef<Array<number>>([0]);
    const arrHeightRef = useRef<Array<number>>([]);
    const [tabActive, setTabActive] = useState<string>('1');
    const [tabActive2, setTabActive2] = useState<string>('1');

    // 设置偏移量
    const [transformX, setTransformX] = useState(470);
    // 记录热键：当前展示区域的第一个list的key
    const [reactiveKey, setReativeKey] = useState(0);
    // 记录完整显示的列表个数：向下取整
    const screenShowItemsNumber = Math.floor((globalThis.innerWidth - animation.translateX) / (list.listWidth + list.listGap));
    // icon是否活性状态（非活性默认不显示）
    const [activeIconPrev, setActiveIconPrev] = useState(false);
    const [activeIconNext, setActiveIconNext] = useState(true);

    const listContainerRef: any = useRef();

    const sliderData = [
        {
            avatarUrl: [require('@publicLocal/blade/detail/pc/i_user_a.webp'), require('@publicLocal/blade/detail/pc/i_user_a.png')],
            title: t('detail.carabox_a_user'),
            desc: t('detail.carabox_a_desc'),
            imgUrl: [require('@publicLocal/blade/detail/pc/i_user_a_pic.webp'), require('@publicLocal/blade/detail/pc/i_user_a_pic.png')],
        },
        {
            avatarUrl: [require('@publicLocal/blade/detail/pc/i_user_b.webp'), require('@publicLocal/blade/detail/pc/i_user_b.png')],
            title: t('detail.carabox_b_user'),
            desc: t('detail.carabox_b_desc'),
            imgUrl: [require('@publicLocal/blade/detail/pc/i_user_b_pic.webp'), require('@publicLocal/blade/detail/pc/i_user_b_pic.png')],
        },
        {
            avatarUrl: [require('@publicLocal/blade/detail/pc/i_user_c.webp'), require('@publicLocal/blade/detail/pc/i_user_c.png')],
            title: t('detail.carabox_c_user'),
            desc: t('detail.carabox_c_desc'),
            imgUrl: [require('@publicLocal/blade/detail/pc/i_user_c_pic.webp'), require('@publicLocal/blade/detail/pc/i_user_c_pic.png')],
        },
    ];

    const initMove = useCallback((dom: any, arrHRef: number[], arrTRef: number[], offset: number) => {
        const child = dom.children;
        const len = child?.length || 0;
        for (let i = 0; i < len - 1; i++) {
            const item = child[i];

            arrHRef.push(item.clientWidth);

            if (i === len - 2) {
                break;
            }
            if (i !== 0) {
                arrTRef.push(arrTRef[i] + item.clientWidth + offset);
            } else {
                arrTRef.push(item.clientWidth + offset);
            }
        }
    }, []);
    const initMove2 = useCallback((dom: any, arrHRef: number[], arrTRef: number[], offset: number) => {
        const child = dom.children;
        const len = child?.length || 0;
        for (let i = 0; i < len - 1; i++) {
            const item = child[i];

            arrHRef.push(item.clientHeight);

            if (i === len - 2) {
                break;
            }
            if (i !== 0) {
                arrTRef.push(arrTRef[i] + item.clientHeight + offset);
            } else {
                arrTRef.push(item.clientHeight + offset);
            }
        }
    }, []);

    const changeTab = useCallback((index: string) => {
        setTabActive(index);
        const ind = Number(index) - 1;

        (domChildRef.current as HTMLDivElement).style.cssText = `width: ${arrWidthRef.current[ind]}px; left: ${arrLeftRef.current[ind]}px`;
    }, []);
    const changeTab2 = useCallback((index: string) => {
        setTabActive2(index);
        changeQRCodeUrl(index);
        const ind = Number(index) - 1;
        (domChildRef2.current as HTMLDivElement).style.cssText = `height: ${arrHeightRef.current[ind]}px; top: ${arrTopRef.current[ind]}px`;
    }, []);

    // 打开bladei-c-box容器的弹窗
    const openWinCar = (openFlag: boolean) => {
        setOpenWinCarFlag(true);
        if (typeof document !== 'undefined') {
            document.body.classList.add('ef-has-modal-full-viewport');
        }
    };

    // 隐藏bladei-c-box容器的弹窗
    const hideWinCar = (openFlag: boolean) => {
        setOpenWinCarFlag(false);
        if (typeof document !== 'undefined') {
            document.body.classList.remove('ef-has-modal-full-viewport');
        }
    };

    // 设置qrCodeUrl
    const changeQRCodeUrl = (index: string) => {
        setQRCodeUrl(`${window?.origin}/${router.locale}/ar?glb=/models/blade/blade_treaser_${index}.glb&redirect=/${router.locale}/blade-robotic-lawn-mower`);
    };

    /**
     * 动画效果
     * @param steps 动画滑动几张, 默认1
     * @param moveX x轴滑动偏移量(list宽+list间距)
     * @param direction 滑动方向 1: 左滑(上一张) -1. 右滑(下一张)
     */
    const animate = (steps: number, moveX: number, direction: number) => {
        const originX = parseInt(listContainerRef?.current?.style?.transform.split('(')[1]);
        listContainerRef?.current?.animate(
            [{ transform: `translate3d(${originX}px, 0, 0)` }, { transform: `translate3d(${originX + moveX * steps * direction}px, 0, 0)` }],
            {
                duration: 500,
                delay: 0,
                fill: 'forwards',
                easing: 'ease',
                iterations: 1,
            },
        );
        setTransformX(originX + moveX * steps * direction);
        setReativeKey(reactiveKey - steps * direction);
    };
    // 左滑
    const clickPrev = () => {
        if (reactiveKey > 0) {
            animate(animation.steps, list.listWidth + list.listGap, 1);
        }
    };
    // 右滑
    const clickNext = () => {
        if (reactiveKey + screenShowItemsNumber < sliderData.length) {
            animate(animation.steps, list.listWidth + list.listGap, -1);
        }
    };

    useEffect(() => {
        setTransformX((document.body.clientWidth - 980) / 2);
        initMove(domRef.current, arrWidthRef.current, arrLeftRef.current, 48);
        changeTab('1');
        initMove2(domRef2.current, arrHeightRef.current, arrTopRef.current, 17);
        changeTab2('1');
        changeQRCodeUrl('1');
        window.addEventListener('resize', () => {
            setTransformX((document.body.clientWidth - 980) / 2);
        });
    }, []);

    useEffect(() => {
        setActiveIconPrev(reactiveKey > 0);
        setActiveIconNext(reactiveKey + screenShowItemsNumber < sliderData.length);
    }, [reactiveKey]);

    const getDataLayer = (list_name: string) => {
        return {
            event: 'uaEvent',
            event_name: 'click_checklist',
            product_name: 'EcoFlow BLADE',
            list_name,
        };
    };

    return (
        <div className={`${css['blade-I']}`}>
            <div id="other" className="bladei-title bladei-title-a">
                {t('detail.carabox_title')}
            </div>
            <div className="bladei-carabox">
                <div
                    className="arrowIcon prevIcon"
                    onClick={clickPrev}
                    style={{
                        display: activeIconPrev ? 'flex' : 'none',
                        width: `${icon.width}px`,
                        height: `${icon.height}px`,
                        borderRadius: '50%',
                        top: `${list.listHeight / 2}px`,
                        left: `${icon.iconPositionBetween}px`,
                    }}
                >
                    <EFArrowDown className="icon" />
                </div>
                <div className="bladei-carabox-in" ref={listContainerRef} style={{ transform: `translate3d(${transformX}px, 0,0)` }}>
                    <Swiper width={480} spaceBetween={20} grabCursor>
                        {sliderData.map((item, index) => {
                            return (
                                <SwiperSlide key={index} className="bladei-item">
                                    <div className="bladei-user">
                                        <div className="bladei-user-l">
                                            <NextImage webpSrc={item.avatarUrl[0]} src={item.avatarUrl[1]} />
                                        </div>
                                        <div className="bladei-user-r">
                                            <div className="bladei-user-line1">{item.title}</div>
                                            <div className="bladei-user-line2">
                                                <span className="bladei-star"></span>
                                                <span className="bladei-star"></span>
                                                <span className="bladei-star"></span>
                                                <span className="bladei-star"></span>
                                                <span className="bladei-star"></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="bladei-tipicon"></div>
                                    <div className="bladei-desc">{item.desc}</div>
                                    <div className="bladei-img">
                                        <NextImage webpSrc={item.imgUrl[0]} src={item.imgUrl[1]} />
                                    </div>
                                </SwiperSlide>
                            );
                        })}
                    </Swiper>
                </div>
                <div
                    className="arrowIcon nextIcon"
                    onClick={clickNext}
                    style={{
                        display: activeIconNext ? 'flex' : 'none',
                        width: `${icon.width}px`,
                        height: `${icon.height}px`,
                        borderRadius: '50%',
                        top: `${list.listHeight / 2}px`,
                        right: `${icon.iconPositionBetween}px`,
                    }}
                >
                    <EFArrowDown className="icon" />
                </div>
            </div>
            <div className="bladei-title bladei-title-b">{t('detail.carabox_b_title')}</div>
            <div className="bladei-b-swiper">
                <Swiper
                    modules={[Pagination]}
                    navigation={true}
                    pagination={{
                        clickable: true,
                    }}
                    spaceBetween={20}
                    width={800}
                    slidesPerView={'auto'}
                    grabCursor
                >
                    <SwiperSlide className="swiper-smart-list">
                        <NextImage
                            webpSrc={require('@publicLocal/blade/detail/pc/i_action_1.webp')}
                            src={require('@publicLocal/blade/detail/pc/i_action_1.jpg')}
                        />
                    </SwiperSlide>
                    <SwiperSlide className="swiper-smart-list">
                        <NextImage
                            webpSrc={require('@publicLocal/blade/detail/pc/i_action_2.webp')}
                            src={require('@publicLocal/blade/detail/pc/i_action_2.jpg')}
                        />
                    </SwiperSlide>
                    <SwiperSlide className="swiper-smart-list">
                        <NextImage
                            webpSrc={require('@publicLocal/blade/detail/pc/i_action_3.webp')}
                            src={require('@publicLocal/blade/detail/pc/i_action_3.jpg')}
                        />
                    </SwiperSlide>
                    <SwiperSlide className="swiper-smart-list">
                        <NextImage
                            webpSrc={require('@publicLocal/blade/detail/pc/i_action_4.webp')}
                            src={require('@publicLocal/blade/detail/pc/i_action_4.jpg')}
                        />
                    </SwiperSlide>
                </Swiper>
            </div>
            <div className="bladei-title bladei-title-c">{t('detail.carabox_c_title')}</div>
            <div className={`bladei-c-box ${tabActive === '1' ? 'active-blade' : 'active-lawn'}`}>
                <div className="bladei-c-box-l">
                    <div className="bladei-c-l-item bladei-c-l-item1">
                        <div className="bladei-c-h">
                            <EFBladeiCIcon1 className="bladei-c-h-icon" />
                            <div className="bladei-c-h-msg">{t('detail.bladei_c_cara_ms1')}</div>
                        </div>
                        <div className="bladei-c-l-img">
                            <Model3D
                                props={{
                                    style: { width: '440px', height: '400px', margin: '0 auto' },
                                    src: '/models/blade/blade_treaser_1.glb',
                                }}
                            />
                        </div>
                    </div>
                    <div className="bladei-c-l-item bladei-c-l-item2">
                        <div className="bladei-c-h">
                            <EFBladeiCIcon1 className="bladei-c-h-icon" />
                            <span className="bladei-c-h-msg">{t('detail.bladei_c_cara_ms1')}</span>
                        </div>
                        <div className="bladei-c-l-img">
                            <Model3D
                                props={{
                                    style: { width: '440px', height: '400px', margin: '0 auto' },
                                    src: '/models/blade/blade_treaser_2.glb',
                                }}
                            />
                        </div>
                    </div>
                    <div className="tabs">
                        <div ref={domRef} className={`bound-tab active-0${tabActive}`}>
                            <button onClick={() => changeTab('1')}>{t('detail.bladei_c_cara_ms2')}</button>
                            <button onClick={() => changeTab('2')}>{t('detail.bladei_c_cara_ms3')}</button>
                            <span ref={domChildRef}></span>
                        </div>
                    </div>
                </div>
                <div className="bladei-c-box-r">
                    <div className="bladei-c-r-img">
                        <NextImage
                            webpSrc={require('@publicLocal/blade/detail/pc/i_blade_b1.webp')}
                            src={require('@publicLocal/blade/detail/pc/i_blade_b1.jpg')}
                        />
                    </div>
                    <div className="bladei-c-r-msg">
                        <div className="bladei-c-r-line1">{t('detail.bladei_c_boxa_ms1')}</div>
                        <div className="bladei-c-r-line2" onClick={openWinCar}>
                            <span>{t('detail.bladei_c_boxa_ms2')}</span>
                            <EFArrowRight color={'#386FE4'} className="bladei-c-h-icon" />
                        </div>
                    </div>
                </div>
            </div>
            <div className={`blade-win-card-out${openWinCarFlag ? ' show-win-car' : ''}`}>{openWinCarFlag && <WinCard callback={hideWinCar} />}</div>
            <div className={`bladei-d-box ${tabActive2 === '1' ? 'active-blade' : 'active-lawn'}`}>
                {tabActive2 === '1' ? (
                    <div className="bladei-d-img1">
                        <NextImage webpSrc={require('@publicLocal/blade/detail/pc/14-3@2x.webp')} src={require('@publicLocal/blade/detail/pc/14-3@2x.jpg')} />
                    </div>
                ) : (
                    <div className="bladei-d-img1">
                        <NextImage webpSrc={require('@publicLocal/blade/detail/pc/14-5@2x.webp')} src={require('@publicLocal/blade/detail/pc/14-5@2x.jpg')} />
                    </div>
                )}

                <div className="qr-code">
                    <QRCode value={qrcodeUrl} renderAs="canvas" size={100} />
                </div>
                <div className="bladei-d-line1">{t('detail.bladei_c_boxb_ms1')}</div>
                <p className="desc">{t('detail.only_apple_support')}</p>
                <div ref={domRef2} className={`character-tab active-0${tabActive2}`}>
                    <button onClick={() => changeTab2('1')}>
                        <span className="title">{t('detail.bladei_c_boxb_ms2')}</span>
                    </button>
                    <button onClick={() => changeTab2('2')}>
                        <span className="title">{t('detail.bladei_c_boxb_ms3')}</span>
                    </button>
                    <em ref={domChildRef2}></em>
                </div>
            </div>
            <div className="bladei-e-box">
                <div className="bladei-e-l">
                    <NextImage webpSrc={require('@publicLocal/blade/detail/pc/i_ebox_1.webp')} src={require('@publicLocal/blade/detail/pc/i_ebox_1.jpg')} />
                </div>
                <div className="bladei-e-r">
                    <p className="bladei-e-h">{t('detail.bladei_e_ms1')}</p>
                    <p className="bladei-e-desc">{t('detail.bladei_e_ms2')}</p>
                    {/* <p className="bladei-e-btn">
                        {t('detail.bladei_e_ms3')}
                        <span className="ef-arricon"></span>
                    </p> */}
                    <Link className="bladei-e-btn" href={'/blade-robotic-lawn-mower-checklist'} dataLayer={getDataLayer(t('detail.bladei_e_ms1'))}>
                        {t('detail.bladei_e_ms3')}
                        <EFArrowRight color={'#fff'} className="bladei-e-icon" />
                    </Link>
                </div>
            </div>
            <div className="bladei-title bladei-title-f">{t('detail.bladei_f_title')}</div>

            <div className="bladei-f-box">
                <div className="bladei-f-l">
                    <div className="bladei-f-card">
                        <p className="bladei-f-msg">{t('detail.bladei_f_card1')}</p>
                        <div className="bladei-f-img">
                            <NextImage webpSrc={require('@publicLocal/blade/detail/pc/1.webp')} src={require('@publicLocal/blade/detail/pc/1.png')} />
                        </div>
                    </div>
                </div>
                <div className="bladei-f-r">
                    <div className="bladei-f-card">
                        <p className="bladei-f-msg">{t('detail.bladei_f_card3')}</p>
                        <div className="bladei-f-img">
                            <NextImage webpSrc={require('@publicLocal/blade/detail/pc/2.webp')} src={require('@publicLocal/blade/detail/pc/2.png')} />
                        </div>
                    </div>
                    <div className="bladei-f-card">
                        <p className="bladei-f-msg">{t('detail.bladei_f_card4')}</p>
                        <div className="bladei-f-img">
                            <NextImage webpSrc={require('@publicLocal/blade/detail/pc/3.webp')} src={require('@publicLocal/blade/detail/pc/3.png')} />
                        </div>
                    </div>
                    <div className="bladei-f-card">
                        <p className="bladei-f-msg">{t('detail.bladei_f_card5')}</p>
                        <div className="bladei-f-img">
                            <NextImage webpSrc={require('@publicLocal/blade/detail/pc/4.webp')} src={require('@publicLocal/blade/detail/pc/4.png')} />
                        </div>
                    </div>
                    <div className="bladei-f-card">
                        <p className="bladei-f-msg">{t('detail.bladei_f_card6')}</p>
                        <div className="bladei-f-img">
                            <NextImage webpSrc={require('@publicLocal/blade/detail/pc/5.webp')} src={require('@publicLocal/blade/detail/pc/5.png')} />
                        </div>
                    </div>
                    <div className="bladei-f-card bladei-f-card-two">
                        <p className="bladei-f-msg">{t('detail.bladei_f_card2')}</p>
                        <div className="bladei-f-img">
                            <NextImage webpSrc={require('@publicLocal/blade/detail/pc/6.webp')} src={require('@publicLocal/blade/detail/pc/6.png')} />
                        </div>
                    </div>
                </div>
            </div>
            {/* <div className="bladei-title-f-tips">{t('detail.bladei_f_tips')}</div> */}
        </div>
    );
}
